import io from 'socket.io-client';
import { getToken } from './localstage-actions';

export const socket = io.connect(process.env.REACT_APP_BASE_API_URL_FOR_SOCKET || '', {
	query: { token: getToken() },
});
